import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import LoadingScreen from 'components/LoadingScreen';
import { quickPurchaseAttemptTracker } from 'metrics/user-analytics/purchase';

/**
 * NewQuickPurchase component.
 * Create a new purchase and redirect to the quick-checkout screen.
 * Shows a loading screen while the purchase is being created.
 * @param {object} props - createPurchase, replaceUrl, passengersParam, seatsParam, unlockPurchaseSeats.
 */
const NewQuickPurchase = ({
  createPurchase,
  replaceUrl,
  passengersParam,
  seatsParam,
  unlockPurchaseSeats,
}) => {
  useEffect(() => {
    let isMounted = true;

    quickPurchaseAttemptTracker();

    createPurchase().then((token) => {
      if (!token) return;

      if (!isMounted) {
        // The user navigated away before the purchase was created. Unlike the normal
        // purchase flow (NewPurchase.js), Quick Purchase pre-selects seats when calling
        // newPurchase, so we must release them explicitly to restore inventory.
        unlockPurchaseSeats(token);
        return;
      }

      const queryParts = [`passengers=${passengersParam}`];
      if (seatsParam) queryParts.push(`seats=${seatsParam}`);
      replaceUrl(`/purchase/${token}/quick-checkout?${queryParts.join('&')}`);
    });

    return () => {
      isMounted = false;
    };
    // Props are stable references from mapDispatchToProps — safe to capture at mount only
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <LoadingScreen backgroundColor="white" hasHeader={false} />;
};

NewQuickPurchase.propTypes = {
  createPurchase: PropTypes.func.isRequired,
  replaceUrl: PropTypes.func.isRequired,
  passengersParam: PropTypes.string.isRequired,
  seatsParam: PropTypes.string,
  unlockPurchaseSeats: PropTypes.func.isRequired,
};

NewQuickPurchase.defaultProps = {
  seatsParam: null,
};

export default NewQuickPurchase;
